// extracted by mini-css-extract-plugin
module.exports = {"userMenu":"UserTools_userMenu__BEea7"};